import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { IThemeState } from '../store/reducers';

export const AppThemeProvider = ({ children }: any) => {
    const tenant:IThemeState = useSelector((state: any) => state.tenantConfig);
    
    const theme = useMemo(() => {
        return createTheme(tenant.IsBelmar ? {
            palette: {
                primary: {
                    main: tenant.PrimaryColor || '#98012e',
                },
                secondary: {
                    main: tenant.SecondaryColor || '#cc3300',
                },
            },
            components: {
                MuiButton: {
                    styleOverrides: {
                        containedPrimary: {
                            '&.Mui-disabled': {
                                backgroundColor: `${tenant.PrimaryColor || '#0066CC'} !important`,
                                color: 'rgba(255, 255, 255, 0.7) !important',
                                opacity: 0.65,
                            },
                        },
                    },
                },
            },
        } : {});
    }, [tenant.Name, tenant.PrimaryColor, tenant.SecondaryColor]
    );
    
    return (
        <ThemeProvider theme={theme}>
            {children}
        </ThemeProvider>
    );
};

